import { render, staticRenderFns } from "./ProductPriceChart.vue?vue&type=template&id=3295fd6e&scoped=true"
import script from "./ProductPriceChart.vue?vue&type=script&lang=js"
export * from "./ProductPriceChart.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceChart.vue?vue&type=style&index=0&id=3295fd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295fd6e",
  null
  
)

export default component.exports